"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getButtonHeight = exports.getButtonWidth = exports.setSVGStyles = exports.SetPosition = void 0;
const styled_components_1 = require("styled-components");
const SetPosition = (position) => {
    switch (position) {
        case 'bottom-left':
            return (0, styled_components_1.css) `
        bottom: 5%;
        left: 5%;
      `;
        case 'bottom-right':
            return (0, styled_components_1.css) `
        bottom: 5%;
        right: 5%;
      `;
        case 'top-left':
            return (0, styled_components_1.css) `
        top: 5%;
        left: 5%;
      `;
        case 'top-right':
            return (0, styled_components_1.css) `
        top: 5%;
        right: 5%;
      `;
        default:
            return (0, styled_components_1.css) `
        position: initial;
      `;
    }
};
exports.SetPosition = SetPosition;
const setSVGStyles = (color, width, height) => {
    return (0, styled_components_1.css) `
    & svg {
      ${width && `width: ${width};`}
      ${height && `height: ${height};`}
    }
    ${color
        ? (0, styled_components_1.css) `
          & svg path[fill*='#'],
          & svg rect[fill*='#'] {
            fill: ${color};
          }
          & svg path[stroke*='#'],
          & svg rect[stroke*='#'] {
            stroke: ${color};
          }
        `
        : null}
  `;
};
exports.setSVGStyles = setSVGStyles;
const getButtonWidth = (isIconButton, isFullWidth, isSmall) => {
    if (isIconButton) {
        return isSmall ? '36px' : '53px';
    }
    if (isFullWidth && !isIconButton) {
        return '100%';
    }
    return 'auto';
};
exports.getButtonWidth = getButtonWidth;
const getButtonHeight = (isIconButton, isSmall) => {
    if (isIconButton) {
        return isSmall ? '36px' : '53px';
    }
    return 'auto';
};
exports.getButtonHeight = getButtonHeight;
//# sourceMappingURL=utils.js.map